"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stacktrace = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _reduce = _interopRequireDefault(require("lodash/reduce"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || (0, _typeof2.default)(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var cleanFileName = function cleanFileName(filename) {
  if (filename) {
    return filename.replace(/webpack:\//g, '');
  }

  return filename;
};

var traceToErrorStack = function traceToErrorStack(err, frames) {
  return (0, _reduce.default)(frames, function (result, frame) {
    return "".concat(result, "\n    at ").concat(frame.functionName || '<anonymous>', " (").concat(cleanFileName(frame.fileName), ":").concat(frame.lineNumber, ":").concat(frame.columnNumber, ")");
  }, "".concat(err.toString()));
};

var stacktrace = function stacktrace(err) {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require('stacktrace-js'));
  }).then(function (stackTrace) {
    return stackTrace.fromError(err);
  }).then(function (frames) {
    return traceToErrorStack(err, frames);
  });
};

exports.stacktrace = stacktrace;